import { useSelector } from "react-redux";

import { RootState } from "@/store/store";
import priceFormatter from "@/utils/priceFormatter";
import Title from "@/shared/components/Title/Title";
import { totalPriceCounter } from "@/services/API/totalPriceCounter";

export default function BlockTotalInfo() {
    const isEditAppointment = useSelector(
        (state: RootState) => state.ui.isEditAppointment,
    );
    const currentAppointment = useSelector((state: RootState) =>
        isEditAppointment
            ? state.appointments.existtAppointment
            : state.appointments.newAppointment,
    );
    const { services, paymentHistory } = currentAppointment;

    const sum = totalPriceCounter(services);

    const payments = paymentHistory.reduce(
        (accum, item) => accum + Number(item.amount),
        0,
    );

    return (
        <div className='summary_container'>
            <Title tag='h2' text={"Всього"} span={priceFormatter(sum)} />
            <Title
                tag='h2'
                text={"Оплачено"}
                span={priceFormatter(payments)}
                style={{ color: "#47586E" }}
            />
            <Title
                tag='h2'
                text={"Борг"}
                span={priceFormatter(sum - payments)}
                style={{ color: "#AD1313" }}
            />
        </div>
    );
}
